import { createActions } from '../../../utils/actionHelpers';

export default {
  ...createActions({
    resource: 'collection',
    verbs: ['fetch'],
    prefix: 'collections',
  }),
};
